import { PAYMENT_ID, PAYMENT_PROVIDER } from "../utils/payment";
import { Card } from "./Card";
import { PaymentRequestData } from "./PaymentRequestData";

export class PaymentMethod {
  constructor(
    paymentMethodCode,
    paymentProvider,
    paymentMethod,
    autoConfirm,
    isPrimary,
    meta,
    content,
    bank,
    accountName,
    accountNumber,
    branch,
    hide,
    paymentRequest,
    merchantCountry,
  ) {
    this.paymentMethodCode = paymentMethodCode;
    this.paymentProvider = paymentProvider;
    this.paymentMethod = paymentMethod;
    this.autoConfirm = autoConfirm;
    this.isPrimary = isPrimary;
    this.meta = meta;
    this.content = content;
    this.bank = bank;
    this.accountName = accountName;
    this.accountNumber = accountNumber;
    this.branch = branch;
    this.hide = hide;
    this.paymentRequest = paymentRequest;
    this.merchantCountry = merchantCountry;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new PaymentMethod(
        input.payment_method_code,
        input.payment_provider,
        input.payment_method,
        input.auto_confirm,
        input.is_primary,
        Card.fromApiObject(input.meta),
        input.content,
        input.bank,
        input.account_name,
        input.account_number,
        input.branch,
        input.hide,
        PaymentRequestData.fromApiObject(input.payment_request),
        input.merchant_country,
      )
    }

    return new PaymentMethod();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => PaymentMethod.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [PaymentMethod.fromApiObject(input)];
    }

    return [];
  }

  /**
   * @returns {{ paymentMethod, paymentProvider, label, icon, placeholder }}
   */
  static getPaymentItem(listPaymentMethod, paymentMethod, paymentProvider) {
    if (!listPaymentMethod?.length) {
      return false;
    }
    return listPaymentMethod.find(item => item.paymentMethod === paymentMethod && (item?.paymentProvider || paymentProvider) === paymentProvider);
  }

  static getPaymentItems(listPaymentMethod, paymentMethod, paymentProvider) {
    if (!listPaymentMethod?.length) {
      return false;
    }
    return listPaymentMethod.filter(item => item.paymentMethod === paymentMethod && (item?.paymentProvider || paymentProvider) === paymentProvider);
  }

  static getInfoACB(listPaymentMethod) {
    if (!listPaymentMethod?.length) {
      return false;
    }
    return listPaymentMethod.find(item => this.isACB(item.paymentMethod, item.paymentProvider));
  }

  /**
   * @param {[PaymentMethod]} listPaymentMethod 
   * @returns {PaymentMethod }
   */
  static getStripeGoogle(listPaymentMethod = []) {
    return this.getPaymentItem(listPaymentMethod, PAYMENT_ID.RECEIVE, PAYMENT_PROVIDER.STRIPE_GOOGLE);
  }

  /**
   * @param {[PaymentMethod]} listPaymentMethod 
   * @returns {PaymentMethod }
   */
  static getStripeApple(listPaymentMethod = []) {
    return this.getPaymentItem(listPaymentMethod, PAYMENT_ID.RECEIVE, PAYMENT_PROVIDER.STRIPE_APPLE);
  }

  static hasStripe(listPaymentMethod) {
    if (!listPaymentMethod?.length) {
      return false;
    }
    return listPaymentMethod.filter(item => this.isStripe(item.paymentMethod, item.paymentProvider)).length;
  }

  static hasTransfer(listPaymentMethod) {
    if (!listPaymentMethod?.length) {
      return false;
    }
    return listPaymentMethod.filter(item => this.isACB(item.paymentMethod, item.paymentProvider)).length;
  }

  static isACB(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.TRANSFER && paymentProvider === PAYMENT_PROVIDER.ACB;
  }

  static isFundiin(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.RECEIVE && paymentProvider === PAYMENT_PROVIDER.FUNDIIN;
  }

  static isStripe(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.CARD && paymentProvider === PAYMENT_PROVIDER.STRIPE;
  }

  static isCod(paymentMethod) {
    return paymentMethod === PAYMENT_ID.COD;
  }

  static isAppotaPay(paymentMethod, paymentProvider) {
    return (paymentMethod === PAYMENT_ID.ATM || paymentMethod === PAYMENT_ID.CARD) && paymentProvider === PAYMENT_PROVIDER.APPOTA
  }

  static isAppotaAtm(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.ATM && paymentProvider === PAYMENT_PROVIDER.APPOTA;
  }

  static isAppotaCard(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.CARD && paymentProvider === PAYMENT_PROVIDER.APPOTA;
  }

  static isPromotion(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.PROMOTION && paymentProvider === PAYMENT_PROVIDER.ONEPAY;
  }

  static isPaypal(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.RECEIVE && paymentProvider === PAYMENT_PROVIDER.PAYPAL;
  }

  static isGooglePay(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.RECEIVE && paymentProvider === PAYMENT_PROVIDER.GOOGLE;
  }

  static isApplePay(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.RECEIVE && paymentProvider === PAYMENT_PROVIDER.APPLE;
  }

  static isStripeGooglePay(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.RECEIVE && paymentProvider === PAYMENT_PROVIDER.STRIPE_GOOGLE;
  }

  static isStripeApplePay(paymentMethod, paymentProvider) {
    return paymentMethod === PAYMENT_ID.RECEIVE && paymentProvider === PAYMENT_PROVIDER.STRIPE_APPLE;
  }

  static OPTION = {
    SAVED: "saved",
    OTHER: "other",
  }
}